export default function isReadOnlyArray(value) {
  return Array.isArray(value);
}